import React, { useState } from 'react';
import MenuItem from '@mui/material/MenuItem';
import EditOutlinedIcon from '@mui/icons-material/CreateOutlined';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CircularProgress from '@mui/material/CircularProgress';
// import IconButton from '@mui/material/IconButton';
// import CloseIcon from '@mui/icons-material/Close';
import {axios_tenant} from '../../../../axios';
import { useAppContext } from '../AppContext';
// import GetAppOutlinedIcon from '@mui/icons-material/GetAppOutlined';
import { toast } from 'react-toastify';

function RenameMenuItems({ selectedItem, handleCloseContextMenu, showSnackbar, fetchFolderContents }) {
  const appData = useAppContext();
  const [newName, setNewName] = useState(selectedItem.type==="file" ? selectedItem.name.split(".")[0] : selectedItem.name);
  const [isRenaming, setRenaming] = useState(false);
  const [isEditing, setEditing] = useState(false);
  const [error, setError] = useState('');

  const blacklistCharacters = ['.']; // Add more characters as needed

  const handleRenameClick = async () => {

    try {
      const { type, folderId, fileId, fileName } = selectedItem;
      let newNameWithExtension = newName;
      if (type === 'folder' || type === 'file') {
        setRenaming(true);

        // Choose the appropriate endpoint based on the item type
        const renameEndpoint = `/collaboration/renameItem/${type}/${type === 'folder' ? folderId : fileId}`;
        if (type === 'file'){
            const fileExtension = fileName.split('.').pop();
            newNameWithExtension = newName + (fileExtension ? `.${fileExtension}` : '');
        }
        // Trigger the rename request
        await axios_tenant.put(renameEndpoint, { newName: type === 'file'? newNameWithExtension: newName , parentFolderId:appData.folderId});

        // Update the UI or handle success as needed

        // Show success snackbar
        toast.success('Item renamed successfully');
        // showSnackbar('Item renamed successfully');
        fetchFolderContents();
      } 

      handleCloseContextMenu();
    } catch (error) {
      // Show error snackbar
      // toast.error('Item renamed successfully');
      // showSnackbar('Error renaming item', true);
    } finally {
      setRenaming(false);
      setEditing(false);
    }
  };

  const handleMenuItemClick = () => {
    setEditing(true);
  };

  const handleCancelClick = () => {
    setEditing(false);
    setError('');
  };

  const handleRename = (e) => {
    setNewName(e.target.value);

    // Validate the input against the blacklist characters
    const hasBlacklistedCharacter = blacklistCharacters.some((char) => e.target.value.includes(char));

    if (hasBlacklistedCharacter) {
      setError(`File or folder name cannot contain a blacklisted [${blacklistCharacters.join(',')}] character.`);
    } else {
      setError('');
    }
  };

  const isRenameButtonDisabled = !newName.trim() || !!error; // Disable button if the name is empty or contains a blacklisted character

  return (
    <>
      <MenuItem onClick={handleMenuItemClick}>
        <EditOutlinedIcon fontSize="small" style={{ marginRight: 8 }} />
        <span>Rename</span>
      </MenuItem>
      <Dialog open={isEditing} onClose={handleCancelClick}>
        <DialogTitle>Rename {selectedItem.type === 'file'?'File':'Folder'}</DialogTitle>
        <DialogContent style={{ paddingTop: 10 }}>
          <TextField
            label="New Name"
            variant="outlined"
            size="small"
            value={newName}
            onChange={(e) => handleRename(e)}
            onKeyDown={(e) => { e.stopPropagation(); }}
            style={{ marginRight: 8 }}
            required
            error={!!error}
            helperText={error}
            InputProps={{
              endAdornment: (
                <div style={{ display: 'flex', alignItems: 'center', marginLeft: 8 }}>
                  <span style={{ fontWeight: 'bold', color: '#888' }}>
                    {selectedItem.type === 'file' ? `.${selectedItem.fileName.split('.').pop()}` : ''}
                  </span>
                </div>
              ),
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelClick}>Cancel</Button>
          <Button onClick={handleRenameClick} color="primary" disabled={isRenameButtonDisabled}>
            Rename
          </Button>
        </DialogActions>
      </Dialog>
      {isRenaming && <CircularProgress size={20} style={{ marginRight: 8 }} />}
    </>
  );
}

export default RenameMenuItems;
